export default __webpack_public_path__ + "static/media/Ies_Tci.20707ba0.png";